import { render } from "./BioData.vue?vue&type=template&id=64df49bd&scoped=true"
import script from "./BioData.vue?vue&type=script&lang=js"
export * from "./BioData.vue?vue&type=script&lang=js"

import "./BioData.vue?vue&type=style&index=0&id=64df49bd&scoped=true&lang=css"

import exportComponent from "/Users/habeebrahman/Documents/htdocs/cdz_projects/wg-frontend-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64df49bd"]])

export default __exports__